export default Object.freeze({
  Unset: 0,
  EnProceso: 1,
  Completado: 2,
  Error: 3,
});
